module.exports = __webpack_public_path__ + "public/StoreIcon/opertaionHours.svg?cbe1b676";